import { useRef, useCallback } from 'react';

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const useTextScramble = (speed = 20) => {
  const intervalRef = useRef(null);

  const scramble = useCallback((element) => {
    if (!element) return;
    
    const originalText = element.dataset.value || element.innerText;
    element.dataset.value = originalText;
    
    let iteration = 0;
    
    clearInterval(intervalRef.current);
    
    intervalRef.current = setInterval(() => {
      element.innerText = originalText
        .split("")
        .map((letter, index) => {
          if (index < iteration) {
            return originalText[index];
          }
          
          if (letter === " ") return " ";
          if (letter === "\n") return "\n";
          
          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");
      
      if (iteration >= originalText.length) {
        clearInterval(intervalRef.current);
      }
      
      iteration += 2;
    }, speed);
  }, [speed]);

  const reset = useCallback((element) => {
    if (!element) return;
    clearInterval(intervalRef.current);
    if (element.dataset.value) {
      element.innerText = element.dataset.value;
    }
  }, []);

  return { scramble, reset };
};

const TextScramble = ({ 
  children, 
  as: Component = 'span', 
  className = '',
  speed = 20,
  ...props 
}) => {
  const elementRef = useRef(null);
  const { scramble, reset } = useTextScramble(speed);

  const handleMouseEnter = () => {
    if (elementRef.current) {
      scramble(elementRef.current);
    }
  };

  const handleMouseLeave = () => {
    if (elementRef.current) {
      reset(elementRef.current);
    }
  };

  return (
    <Component
      ref={elementRef}
      className={`text-scramble ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      data-value={children}
      {...props}
    >
      {children}
    </Component>
  );
};

export default TextScramble;
